export enum ValidityTypeEnum {
    ALL = 0,
    MONTH = 1,
    YEAR = 2,
}
export const ValidityType = {
    [ValidityTypeEnum.ALL]: {
        id: ValidityTypeEnum.ALL,
        title: "All"
    },
    [ValidityTypeEnum.MONTH]: {
        id: ValidityTypeEnum.MONTH,
        title: "Month"
    },
    [ValidityTypeEnum.YEAR]: {
        id: ValidityTypeEnum.YEAR,
        title: "Year"
    },
}